import fp from 'lodash/fp';
import React from 'react';
import { Col, Collapse, Row } from 'react-bootstrap';
import { withHandlers, withStateHandlers } from 'recompose';
import { compose } from 'redux';
import { FormField, Icon } from '..';
import { contentLength } from '../../../constants';

const CpdHourFilter = ({
  onCpdHourFilterChange,
  toggleFilter,
  showFilter
}) => (
    <div className='filter cpd-hour-filter'>
      <Row className='button-gutter'>
        <Col xs={12}>
          <h2
            className='flexbox justify-between'
            type='button'
            onClick={toggleFilter}
            aria-expanded={showFilter}
            aria-controls='filter'>
            Filter by content length
            {
              showFilter ?
                <Icon icon='minus-large'></Icon> :
                <Icon icon='plus-large'></Icon>
            }
          </h2>
        </Col>
      </Row>
      <Collapse id="cpd-hour-filter" in={showFilter}>
        <form noValidate>
          <fieldset>
            <FormField id='cpd-hour' label='Content length' type='select-item'>
              <select
                id='cpd-hour'
                required
                onChange={(e) => onCpdHourFilterChange(e)}>
                <option value={undefined}></option>
                {
                  fp.flow(
                    fp.keys,
                    fp.map((key) => <option key={key} value={key}>{fp.get(key)(contentLength).label}</option>)
                  )(contentLength)
                }
              </select>
            </FormField>
          </fieldset>
        </form>
      </Collapse>
    </div>
  )

export default compose(
  withStateHandlers(
    {
      showFilter: false
    },
    {
      toggleFilter: ({ showFilter }) => () => ({
        showFilter: !showFilter
      })
    }
  ),
  withHandlers({
    onCpdHourFilterChange: ({ onChange }) => (e) => {
      const updatedMinCpdHours = e.target.value ? fp.get(e.target.value)(contentLength).min : undefined;
      const updatedMaxCpdHOurs = e.target.value ? fp.get(e.target.value)(contentLength).max : undefined;
      onChange(updatedMinCpdHours, updatedMaxCpdHOurs);
    }
  })
)(CpdHourFilter)


// WEBPACK FOOTER //
// ./src/containers/components/filters/cpd-hour-filter.js